import { render, staticRenderFns } from "./BranchMembers.vue?vue&type=template&id=72e0ae56"
import script from "./BranchMembers.vue?vue&type=script&lang=js"
export * from "./BranchMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports